import * as React from 'react';
import {createView, view} from '@sail/engine';
import {Section} from '@sail/helm';
import type {SectionProps} from '@sail/helm';
import {Markdown} from 'mkt-ssr/components/sail/Markdown';
import {styles} from 'mkt-ssr/components/sail/MarkdownSection/MarkdownSectionStyles';

export type MarkdownSectionProps = SectionProps & {
  /**
   * Markdown string to be rendered
   */
  markdown: string;
};

export const MarkdownSection = createView(
  ({markdown, ...rest}: MarkdownSectionProps) => {
    return (
      <Section {...rest} padding="small">
        <view.div
          className="ArticleMarkdown ArticleMarkdown--mediaQuery"
          uses={[styles.markdownStyles, styles.markdownMediaStyles]}
        >
          <Markdown markdown={markdown} />
        </view.div>
      </Section>
    );
  },
);
